import React from 'react';
import { NavLink, Link, useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  LayoutDashboard,
  Settings,
  Package,
  FileText,
  Star,
  Image,
  Navigation,
  Code,
  Sparkles,
  LogOut,
  Home,
} from 'lucide-react';
import { Button } from '../ui/button';
import { Toaster } from '../ui/sonner';

const sidebarItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/bambam' },
  { icon: Settings, label: 'Site Settings', path: '/bambam/settings' },
  { icon: Package, label: 'Products', path: '/bambam/products' },
  { icon: FileText, label: 'Pages', path: '/bambam/pages' },
  { icon: Star, label: 'Reviews', path: '/bambam/reviews' },
  { icon: Image, label: 'Media', path: '/bambam/media' },
  { icon: Navigation, label: 'Navigation', path: '/bambam/navigation' },
  { icon: Code, label: 'SEO & Schema', path: '/bambam/seo' },
  { icon: Sparkles, label: 'AI Content', path: '/bambam/ai' },
];

export const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/bambam/login');
  };

  return (
    <div className="min-h-screen bg-slate-100 flex">
      {/* Sidebar */}
      <aside className="admin-sidebar w-64 flex-shrink-0 flex flex-col">
        <div className="p-6 border-b border-slate-700">
          <h1 className="font-heading text-xl font-bold text-white">Admin Panel</h1>
          <p className="text-sm text-slate-400 mt-1">Welcome, {user?.username}</p>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {sidebarItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/bambam'}
              className={({ isActive }) =>
                `admin-sidebar-item flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium ${
                  isActive ? 'active text-white' : 'text-slate-300 hover:text-white'
                }`
              }
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <item.icon size={18} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-slate-700 space-y-2">
          <Link to="/" target="_blank">
            <Button variant="outline" className="w-full justify-start gap-2 text-slate-300 border-slate-600 hover:bg-slate-700 hover:text-white">
              <Home size={18} />
              View Site
            </Button>
          </Link>
          <Button
            variant="ghost"
            className="w-full justify-start gap-2 text-slate-400 hover:text-white hover:bg-slate-700"
            onClick={handleLogout}
            data-testid="logout-btn"
          >
            <LogOut size={18} />
            Logout
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <div className="p-8">
          <Outlet />
        </div>
      </main>

      <Toaster position="top-right" />
    </div>
  );
};

export default AdminLayout;
